export default {
  origin: window.location.origin,
  // baseUrl: window.location.port == '1111'?'http://localhost:9120/clueAdmin/':window.location.origin+'/clueAdmin/',
  baseUrl: '/clueAdmin/',
  imageUrl: window.location.host === 'clue.cxhcf.com' ? 'https://csz-public.oss-cn-hangzhou.aliyuncs.com/' : 'https://csz-test.oss-cn-hangzhou.aliyuncs.com/',
  h5Url: window.location.host === 'clue.cxhcf.com' ? 'https://clue.cxhcf.com/' : 'https://test.chexiaohua.cn/',
  pageSize: 7
}
